module.exports = __webpack_public_path__ + "static/media/ag.43f5ec5f.svg";